import './shop/quantity';
import './shop/dismissable';
import './shop/variant-selector';

import contentSingleProduct from './shop/content-single-product';
import contentSingleProductGallery from './shop/content-single-product-gallery';
// import contentSingleProductAttributes from './shop/content-single-product-attributes';
import checkout from './shop/checkout';
import addToCart from './shop/add-to-cart';

Alpine.data('contentSingleProduct', contentSingleProduct);
Alpine.data('contentSingleProductGallery', contentSingleProductGallery);
Alpine.data('checkout', checkout);
// Alpine.data('contentSingleProductAttributes`', contentSingleProductAttributes);
Alpine.data('addToCart', addToCart);
